import { render, staticRenderFns } from "./OnlineMenuContactInfo.vue?vue&type=template&id=47130bda&"
import script from "./OnlineMenuContactInfo.vue?vue&type=script&lang=js&"
export * from "./OnlineMenuContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports